import type { ReactNode } from 'react';
import React from 'react';
import { Helmet } from 'react-helmet';
import type { TranslationPath as CommonTranslationPath } from 'c-translation';
import { useCommonTranslation } from 'c-translation';
import { useTheme } from '@mui/styles';
import { greyFieldBackdropColor, rechartsDarkModeCss } from 'c-lib';

const MetaLayout = <TranslationPath extends string = CommonTranslationPath>({
    metaTitle,
    withoutMetaTitlePrefix = false,
    children,
}: {
    metaTitle: TranslationPath;
    withoutMetaTitlePrefix?: boolean;
    children: ReactNode;
}) => {
    const prefix = useCommonTranslation('Meta.pageTitlePrefix');
    const theme = useTheme();
    return (
        <>
            <Helmet>
                <title>
                    {`${!withoutMetaTitlePrefix ? prefix : ''}${useCommonTranslation(metaTitle)}`}
                </title>

                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link
                    href="https://fonts.googleapis.com/css2?family=Rubik:ital,wght@0,300;0,500;0,600;0,700;1,300;1,400;1,500;1,600;1,700&display=swap"
                    rel="stylesheet"
                />

                <style>
                    {`
                    html, body {
                        font-family: ${theme.typography.fontFamily};
                        padding: 0;
                        margin: 0;
                        background: ${theme.palette.custom?.contentBgColor};
                        color-scheme: ${theme.palette.mode};
                    }
                    .greyBackdrop input:-webkit-autofill,
                    .greyBackdrop input:-webkit-autofill:hover,
                    .greyBackdrop input:-webkit-autofill:focus {
                        background-color: transparent !important;
                        -webkit-box-shadow: 0 0 0 1000px ${greyFieldBackdropColor(
                            theme,
                        )} inset !important;
                        filter: none;
                    }
                    ${theme.palette.mode === 'dark' ? rechartsDarkModeCss(theme) : ''}
                `}
                </style>
                <link
                    rel="icon"
                    type="image/png"
                    href="/uniled-site-identity-32.png"
                    sizes="32x32"
                />
            </Helmet>
            {children}
        </>
    );
};

export default MetaLayout;
